export const WEEK = 1000 * 60 * 60 * 24 * 7;
